import React from "react";
import { Modal } from "react-bootstrap";

import styles from "./UniversalModal.module.css";

const UniversalModal = ({
  showModal,
  handleClose,
  title,
  bodyContent,
  footerContent,
}) => {
  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      centered
    >
      <Modal.Header closeButton className={styles["modal-header-custom"]}>
        <Modal.Title className={styles["modal-title-custom"]}>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["modal-body-custom"]}>
        {bodyContent}
      </Modal.Body>
      <Modal.Footer className={styles["modal-footer-custom"]}>
        {footerContent ?? ""}
      </Modal.Footer>
    </Modal>
  );
};

export default UniversalModal;
